import { render, staticRenderFns } from "./PasteButton.vue?vue&type=template&id=8d31d72c"
import script from "./PasteButton.vue?vue&type=script&lang=js"
export * from "./PasteButton.vue?vue&type=script&lang=js"
import style0 from "./PasteButton.vue?vue&type=style&index=0&id=8d31d72c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports